import { getToken } from './auth'
import JsEncrypt from 'jsencrypt'
import config from '@/config'
import { PDFDocument } from 'pdf-lib'
/**
 * 解析js日期
 * @param {string} jsonDate json格式化的日期
 */
export function parseJsonDate (jsonDate) {
  if (!jsonDate || jsonDate.length < 6) return ''
  // 格式类似：/Date(1410364800000-0000)/
  return new Date(parseInt(jsonDate.substr(6)))
}

/**
 * 把一个js日期类型参数转换成 'yyyy-mm-dd' 格式字符串
 * @param {string} format 日期格式, 如： yyyy-MM-dd hh:mm:ss
 */
export function formatDate (date, format = 'yyyy-MM-dd hh:mm:ss') {
  if (!date) return ''

  let day = date.getDate()
  let month = date.getMonth() + 1
  let year = date.getFullYear()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()

  format = format.replace('MM', month.toString().replace(/^(\d)$/, '0$1'))

  if (format.indexOf('yyyy') > -1) {
    format = format.replace('yyyy', year.toString())
  } else if (format.indexOf('yy') > -1) {
    format = format.replace('yy', year.toString().substr(2, 2))
  }

  format = format.replace('dd', day.toString().replace(/^(\d)$/, '0$1'))

  if (format.indexOf('t') > -1) {
    if (hours > 11) {
      format = format.replace('t', 'pm')
    } else {
      format = format.replace('t', 'am')
    }
  }

  if (format.indexOf('HH') > -1) {
    format = format.replace('HH', hours.toString().replace(/^(\d)$/, '0$1'))
  }

  if (format.indexOf('hh') > -1) {
    if (hours > 12) {
      hours -= 12
    }

    if (hours === 0) {
      hours = 12
    }
    format = format.replace('hh', hours.toString().replace(/^(\d)$/, '0$1'))
  }

  if (format.indexOf('mm') > -1) {
    format = format.replace('mm', minutes.toString().replace(/^(\d)$/, '0$1'))
  }

  if (format.indexOf('ss') > -1) {
    format = format.replace('ss', seconds.toString().replace(/^(\d)$/, '0$1'))
  }

  return format
}
// 获取url参数对象
export const getSearchParams = url => {
  // 获取查询参数前的 ? 对应的索引位置
  const searchIndex = url.indexOf('?')
  // 截取出查询参数字符串，并根据 & 将其分割成一个个 name=bruce 形式字符串组成的数组
  const searchParamsArray = url.slice(searchIndex + 1).split('&')
  // 遍历数组，组成查询参数对象
  return searchParamsArray.reduce((pre, cur) => {
    const [key, value] = cur.split('=')
    return {
      ...pre,
      // 需要使用 decodeURIComponent 对参数进行解码
      [key]: decodeURIComponent(value)
    }
  }, {})
}
/**
 * 把布尔值转换成中文
 * @param {bool} value 布尔值
 */
export function toBoolText (value) {
  return value ? '是' : '否'
}

/**
 * 根据使用状态枚举返回对应的文本值
 * @param {string} value 使用状态
 */
export function toUseStatus (value) {
  return value === 'Valid' ? '启用' : '禁用'
}

/**
 * 数组分组
 * @param {array} xs 待分组的数组
 * @param {string} key 分组的key
 */
export function groupBy (xs, key) {
  return xs.reduce(function (rv, x) {
    ;(rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

/**
 * 得到上传控件需要的额外请求头,包括 Accept, Authorization
 */
export function getUploadHeaders () {
  return { Accept: 'application/json', Authorization: `Bearer ${getToken()}` }
}

export function getLastWeekData () {
  // 获得上周周一~周日的年月日
  var lastweek = []
  var date = new Date()
  // 上周一的日期
  date.setDate(date.getDate() - date.getDay() - 6)
  lastweek.push(date.getMonth() + 1 + '.' + date.getDate())
  for (let i = 1; i < 7; i++) {
    date.setDate(date.getDate() + 1)
    lastweek.push(date.getMonth() + 1 + '.' + date.getDate())
  }
  return lastweek
}

export function encryptAccount (params) {
  const obj = {
    ...params
  }
  const jstr = JSON.stringify(obj)
  const encryptor = new JsEncrypt()
  encryptor.setPublicKey(config.publicKey)
  return encryptor.encrypt(jstr)
}

export function copyToClip (content, cb) {
  var aux = document.createElement('input')
  aux.setAttribute('value', content)
  document.body.appendChild(aux)
  aux.select()
  document.execCommand('copy')
  document.body.removeChild(aux)
  if (cb) cb()
}
// 简繁转换
export function Exchange (text, currentEncoding) {
  let result = ''
  let j
  let s =
    '万与丑专业丛东丝丢两严丧个丬丰临为丽举么义乌乐乔习乡书买乱争于亏云亘亚产亩亲亵亸亿仅从仑仓仪们价众优伙会伛伞伟传伤伥伦伧伪伫体余佣佥侠侣侥侦侧侨侩侪侬俣俦俨俩俪俭债倾偬偻偾偿傥傧储傩儿兑兖党兰关兴兹养兽冁内冈册写军农冢冯冲决况冻净凄凉凌减凑凛几凤凫凭凯击凼凿刍划刘则刚创删别刬刭刽刿剀剂剐剑剥剧劝办务劢动励劲劳势勋勐勚匀匦匮区医华协单卖卢卤卧卫却卺厂厅历厉压厌厍厕厢厣厦厨厩厮县参叆叇双发变叙叠叶号叹叽吁后吓吕吗吣吨听启吴呒呓呕呖呗员呙呛呜咏咔咙咛咝咤咴咸哌响哑哒哓哔哕哗哙哜哝哟唛唝唠唡唢唣唤唿啧啬啭啮啰啴啸喷喽喾嗫呵嗳嘘嘤嘱噜噼嚣嚯团园囱围囵国图圆圣圹场坂坏块坚坛坜坝坞坟坠垄垅垆垒垦垧垩垫垭垯垱垲垴埘埙埚埝埯堑堕塆墙壮声壳壶壸处备复够头夸夹夺奁奂奋奖奥妆妇妈妩妪妫姗姜娄娅娆娇娈娱娲娴婳婴婵婶媪嫒嫔嫱嬷孙学孪宁宝实宠审宪宫宽宾寝对寻导寿将尔尘尧尴尸尽层屃屉届属屡屦屿岁岂岖岗岘岙岚岛岭岳岽岿峃峄峡峣峤峥峦崂崃崄崭嵘嵚嵛嵝嵴巅巩巯币帅师帏帐帘帜带帧帮帱帻帼幂幞干并广庄庆庐庑库应庙庞废庼廪开异弃张弥弪弯弹强归当录彟彦彻径徕御忆忏忧忾怀态怂怃怄怅怆怜总怼怿恋恳恶恸恹恺恻恼恽悦悫悬悭悯惊惧惨惩惫惬惭惮惯愍愠愤愦愿慑慭憷懑懒懔戆戋戏戗战戬户扎扑扦执扩扪扫扬扰抚抛抟抠抡抢护报担拟拢拣拥拦拧拨择挂挚挛挜挝挞挟挠挡挢挣挤挥挦捞损捡换捣据捻掳掴掷掸掺掼揸揽揿搀搁搂搅携摄摅摆摇摈摊撄撑撵撷撸撺擞攒敌敛数斋斓斗斩断无旧时旷旸昙昼昽显晋晒晓晔晕晖暂暧札术朴机杀杂权条来杨杩杰极构枞枢枣枥枧枨枪枫枭柜柠柽栀栅标栈栉栊栋栌栎栏树栖样栾桊桠桡桢档桤桥桦桧桨桩梦梼梾检棂椁椟椠椤椭楼榄榇榈榉槚槛槟槠横樯樱橥橱橹橼檐檩欢欤欧歼殁殇残殒殓殚殡殴毁毂毕毙毡毵氇气氢氩氲汇汉污汤汹沓沟没沣沤沥沦沧沨沩沪沵泞泪泶泷泸泺泻泼泽泾洁洒洼浃浅浆浇浈浉浊测浍济浏浐浑浒浓浔浕涂涌涛涝涞涟涠涡涢涣涤润涧涨涩淀渊渌渍渎渐渑渔渖渗温游湾湿溃溅溆溇滗滚滞滟滠满滢滤滥滦滨滩滪漤潆潇潋潍潜潴澜濑濒灏灭灯灵灾灿炀炉炖炜炝点炼炽烁烂烃烛烟烦烧烨烩烫烬热焕焖焘煅煳熘爱爷牍牦牵牺犊犟状犷犸犹狈狍狝狞独狭狮狯狰狱狲猃猎猕猡猪猫猬献獭玑玙玚玛玮环现玱玺珉珏珐珑珰珲琎琏琐琼瑶瑷璇璎瓒瓮瓯电画畅畲畴疖疗疟疠疡疬疮疯疱疴痈痉痒痖痨痪痫痴瘅瘆瘗瘘瘪瘫瘾瘿癞癣癫癯皑皱皲盏盐监盖盗盘眍眦眬着睁睐睑瞒瞩矫矶矾矿砀码砖砗砚砜砺砻砾础硁硅硕硖硗硙硚确硷碍碛碜碱碹磙礼祎祢祯祷祸禀禄禅离秃秆种积称秽秾稆税稣稳穑穷窃窍窑窜窝窥窦窭竖竞笃笋笔笕笺笼笾筑筚筛筜筝筹签简箓箦箧箨箩箪箫篑篓篮篱簖籁籴类籼粜粝粤粪粮糁糇紧絷纟纠纡红纣纤纥约级纨纩纪纫纬纭纮纯纰纱纲纳纴纵纶纷纸纹纺纻纼纽纾线绀绁绂练组绅细织终绉绊绋绌绍绎经绐绑绒结绔绕绖绗绘给绚绛络绝绞统绠绡绢绣绤绥绦继绨绩绪绫绬续绮绯绰绱绲绳维绵绶绷绸绹绺绻综绽绾绿缀缁缂缃缄缅缆缇缈缉缊缋缌缍缎缏缐缑缒缓缔缕编缗缘缙缚缛缜缝缞缟缠缡缢缣缤缥缦缧缨缩缪缫缬缭缮缯缰缱缲缳缴缵罂网罗罚罢罴羁羟羡翘翙翚耢耧耸耻聂聋职聍联聩聪肃肠肤肷肾肿胀胁胆胜胧胨胪胫胶脉脍脏脐脑脓脔脚脱脶脸腊腌腘腭腻腼腽腾膑臜舆舣舰舱舻艰艳艹艺节芈芗芜芦苁苇苈苋苌苍苎苏苘苹茎茏茑茔茕茧荆荐荙荚荛荜荞荟荠荡荣荤荥荦荧荨荩荪荫荬荭荮药莅莜莱莲莳莴莶获莸莹莺莼萚萝萤营萦萧萨葱蒇蒉蒋蒌蓝蓟蓠蓣蓥蓦蔷蔹蔺蔼蕲蕴薮藁藓虏虑虚虫虬虮虽虾虿蚀蚁蚂蚕蚝蚬蛊蛎蛏蛮蛰蛱蛲蛳蛴蜕蜗蜡蝇蝈蝉蝎蝼蝾螀螨蟏衅衔补衬衮袄袅袆袜袭袯装裆裈裢裣裤裥褛褴襁襕见观觃规觅视觇览觉觊觋觌觍觎觏觐觑觞触觯詟誉誊讠计订讣认讥讦讧讨让讪讫训议讯记讱讲讳讴讵讶讷许讹论讻讼讽设访诀证诂诃评诅识诇诈诉诊诋诌词诎诏诐译诒诓诔试诖诗诘诙诚诛诜话诞诟诠诡询诣诤该详诧诨诩诪诫诬语诮误诰诱诲诳说诵诶请诸诹诺读诼诽课诿谀谁谂调谄谅谆谇谈谊谋谌谍谎谏谐谑谒谓谔谕谖谗谘谙谚谛谜谝谞谟谠谡谢谣谤谥谦谧谨谩谪谫谬谭谮谯谰谱谲谳谴谵谶谷豮贝贞负贠贡财责贤败账货质贩贪贫贬购贮贯贰贱贲贳贴贵贶贷贸费贺贻贼贽贾贿赀赁赂赃资赅赆赇赈赉赊赋赌赍赎赏赐赑赒赓赔赕赖赗赘赙赚赛赜赝赞赟赠赡赢赣赪赵赶趋趱趸跃跄跖跞践跶跷跸跹跻踊踌踪踬踯蹑蹒蹰蹿躏躜躯车轧轨轩轪轫转轭轮软轰轱轲轳轴轵轶轷轸轹轺轻轼载轾轿辀辁辂较辄辅辆辇辈辉辊辋辌辍辎辏辐辑辒输辔辕辖辗辘辙辚辞辩辫边辽达迁过迈运还这进远违连迟迩迳迹适选逊递逦逻遗遥邓邝邬邮邹邺邻郁郄郏郐郑郓郦郧郸酝酦酱酽酾酿释里鉅鉴銮錾钆钇针钉钊钋钌钍钎钏钐钑钒钓钔钕钖钗钘钙钚钛钝钞钟钠钡钢钣钤钥钦钧钨钩钪钫钬钭钮钯钰钱钲钳钴钵钶钷钸钹钺钻钼钽钾钿铀铁铂铃铄铅铆铈铉铊铋铍铎铏铐铑铒铕铗铘铙铚铛铜铝铞铟铠铡铢铣铤铥铦铧铨铪铫铬铭铮铯铰铱铲铳铴铵银铷铸铹铺铻铼铽链铿销锁锂锃锄锅锆锇锈锉锊锋锌锍锎锏锐锑锒锓锔锕锖锗错锚锜锞锟锠锡锢锣锤锥锦锨锩锫锬锭键锯锰锱锲锳锴锵锶锷锸锹锺锻锼锽锾锿镀镁镂镃镆镇镈镉镊镌镍镎镏镐镑镒镕镖镗镙镚镛镜镝镞镟镠镡镢镣镤镥镦镧镨镩镪镫镬镭镮镯镰镱镲镳镴镶长门闩闪闫闬闭问闯闰闱闲闳间闵闶闷闸闹闺闻闼闽闾闿阀阁阂阃阄阅阆阇阈阉阊阋阌阍阎阏阐阑阒阓阔阕阖阗阘阙阚阛队阳阴阵阶际陆陇陈陉陕陧陨险随隐隶隽难雏雠雳雾霁霉霭靓静靥鞑鞒鞯鞴韦韧韨韩韪韫韬韵页顶顷顸项顺须顼顽顾顿颀颁颂颃预颅领颇颈颉颊颋颌颍颎颏颐频颒颓颔颕颖颗题颙颚颛颜额颞颟颠颡颢颣颤颥颦颧风飏飐飑飒飓飔飕飖飗飘飙飚飞飨餍饤饥饦饧饨饩饪饫饬饭饮饯饰饱饲饳饴饵饶饷饸饹饺饻饼饽饾饿馀馁馂馃馄馅馆馇馈馉馊馋馌馍馎馏馐馑馒馓馔馕马驭驮驯驰驱驲驳驴驵驶驷驸驹驺驻驼驽驾驿骀骁骂骃骄骅骆骇骈骉骊骋验骍骎骏骐骑骒骓骔骕骖骗骘骙骚骛骜骝骞骟骠骡骢骣骤骥骦骧髅髋髌鬓魇魉鱼鱽鱾鱿鲀鲁鲂鲄鲅鲆鲇鲈鲉鲊鲋鲌鲍鲎鲏鲐鲑鲒鲓鲔鲕鲖鲗鲘鲙鲚鲛鲜鲝鲞鲟鲠鲡鲢鲣鲤鲥鲦鲧鲨鲩鲪鲫鲬鲭鲮鲯鲰鲱鲲鲳鲴鲵鲶鲷鲸鲹鲺鲻鲼鲽鲾鲿鳀鳁鳂鳃鳄鳅鳆鳇鳈鳉鳊鳋鳌鳍鳎鳏鳐鳑鳒鳓鳔鳕鳖鳗鳘鳙鳛鳜鳝鳞鳟鳠鳡鳢鳣鸟鸠鸡鸢鸣鸤鸥鸦鸧鸨鸩鸪鸫鸬鸭鸮鸯鸰鸱鸲鸳鸴鸵鸶鸷鸸鸹鸺鸻鸼鸽鸾鸿鹀鹁鹂鹃鹄鹅鹆鹇鹈鹉鹊鹋鹌鹍鹎鹏鹐鹑鹒鹓鹔鹕鹖鹗鹘鹚鹛鹜鹝鹞鹟鹠鹡鹢鹣鹤鹥鹦鹧鹨鹩鹪鹫鹬鹭鹯鹰鹱鹲鹳鹴鹾麦麸黄黉黡黩黪黾注'
  let t =
    '萬與醜專業叢東絲丟兩嚴喪個爿豐臨為麗舉麼義烏樂喬習鄉書買亂爭於虧雲亙亞產畝親褻嚲億僅從侖倉儀們價眾優夥會傴傘偉傳傷倀倫傖偽佇體餘傭僉俠侶僥偵側僑儈儕儂俁儔儼倆儷儉債傾傯僂僨償儻儐儲儺兒兌兗黨蘭關興茲養獸囅內岡冊寫軍農塚馮衝決況凍淨淒涼淩減湊凜幾鳳鳧憑凱擊氹鑿芻劃劉則剛創刪別剗剄劊劌剴劑剮劍剝劇勸辦務勱動勵勁勞勢勳猛勩勻匭匱區醫華協單賣盧鹵臥衛卻巹廠廳曆厲壓厭厙廁廂厴廈廚廄廝縣參靉靆雙發變敘疊葉號歎嘰籲後嚇呂嗎唚噸聽啟吳嘸囈嘔嚦唄員咼嗆嗚詠哢嚨嚀噝吒噅鹹呱響啞噠嘵嗶噦嘩噲嚌噥喲嘜嗊嘮啢嗩唕喚呼嘖嗇囀齧囉嘽嘯噴嘍嚳囁嗬噯噓嚶囑嚕劈囂謔團園囪圍圇國圖圓聖壙場阪壞塊堅壇壢壩塢墳墜壟壟壚壘墾坰堊墊埡墶壋塏堖塒塤堝墊垵塹墮壪牆壯聲殼壺壼處備複夠頭誇夾奪奩奐奮獎奧妝婦媽嫵嫗媯姍薑婁婭嬈嬌孌娛媧嫻嫿嬰嬋嬸媼嬡嬪嬙嬤孫學孿寧寶實寵審憲宮寬賓寢對尋導壽將爾塵堯尷屍盡層屭屜屆屬屢屨嶼歲豈嶇崗峴嶴嵐島嶺嶽崠巋嶨嶧峽嶢嶠崢巒嶗崍嶮嶄嶸嶔崳嶁脊巔鞏巰幣帥師幃帳簾幟帶幀幫幬幘幗冪襆幹並廣莊慶廬廡庫應廟龐廢廎廩開異棄張彌弳彎彈強歸當錄彠彥徹徑徠禦憶懺憂愾懷態慫憮慪悵愴憐總懟懌戀懇惡慟懨愷惻惱惲悅愨懸慳憫驚懼慘懲憊愜慚憚慣湣慍憤憒願懾憖怵懣懶懍戇戔戲戧戰戩戶紮撲扡執擴捫掃揚擾撫拋摶摳掄搶護報擔擬攏揀擁攔擰撥擇掛摯攣掗撾撻挾撓擋撟掙擠揮撏撈損撿換搗據撚擄摑擲撣摻摜摣攬撳攙擱摟攪攜攝攄擺搖擯攤攖撐攆擷擼攛擻攢敵斂數齋斕鬥斬斷無舊時曠暘曇晝曨顯晉曬曉曄暈暉暫曖劄術樸機殺雜權條來楊榪傑極構樅樞棗櫪梘棖槍楓梟櫃檸檉梔柵標棧櫛櫳棟櫨櫟欄樹棲樣欒棬椏橈楨檔榿橋樺檜槳樁夢檮棶檢欞槨櫝槧欏橢樓欖櫬櫚櫸檟檻檳櫧橫檣櫻櫫櫥櫓櫞簷檁歡歟歐殲歿殤殘殞殮殫殯毆毀轂畢斃氈毿氌氣氫氬氳彙漢汙湯洶遝溝沒灃漚瀝淪滄渢溈滬濔濘淚澩瀧瀘濼瀉潑澤涇潔灑窪浹淺漿澆湞溮濁測澮濟瀏滻渾滸濃潯濜塗湧濤澇淶漣潿渦溳渙滌潤澗漲澀澱淵淥漬瀆漸澠漁瀋滲溫遊灣濕潰濺漵漊潷滾滯灩灄滿瀅濾濫灤濱灘澦濫瀠瀟瀲濰潛瀦瀾瀨瀕灝滅燈靈災燦煬爐燉煒熗點煉熾爍爛烴燭煙煩燒燁燴燙燼熱煥燜燾煆糊溜愛爺牘犛牽犧犢強狀獷獁猶狽麅獮獰獨狹獅獪猙獄猻獫獵獼玀豬貓蝟獻獺璣璵瑒瑪瑋環現瑲璽瑉玨琺瓏璫琿璡璉瑣瓊瑤璦璿瓔瓚甕甌電畫暢佘疇癤療瘧癘瘍鬁瘡瘋皰屙癰痙癢瘂癆瘓癇癡癉瘮瘞瘺癟癱癮癭癩癬癲臒皚皺皸盞鹽監蓋盜盤瞘眥矓著睜睞瞼瞞矚矯磯礬礦碭碼磚硨硯碸礪礱礫礎硜矽碩硤磽磑礄確鹼礙磧磣堿镟滾禮禕禰禎禱禍稟祿禪離禿稈種積稱穢穠穭稅穌穩穡窮竊竅窯竄窩窺竇窶豎競篤筍筆筧箋籠籩築篳篩簹箏籌簽簡籙簀篋籜籮簞簫簣簍籃籬籪籟糴類秈糶糲粵糞糧糝餱緊縶糸糾紆紅紂纖紇約級紈纊紀紉緯紜紘純紕紗綱納紝縱綸紛紙紋紡紵紖紐紓線紺絏紱練組紳細織終縐絆紼絀紹繹經紿綁絨結絝繞絰絎繪給絢絳絡絕絞統綆綃絹繡綌綏絛繼綈績緒綾緓續綺緋綽緔緄繩維綿綬繃綢綯綹綣綜綻綰綠綴緇緙緗緘緬纜緹緲緝縕繢緦綞緞緶線緱縋緩締縷編緡緣縉縛縟縝縫縗縞纏縭縊縑繽縹縵縲纓縮繆繅纈繚繕繒韁繾繰繯繳纘罌網羅罰罷羆羈羥羨翹翽翬耮耬聳恥聶聾職聹聯聵聰肅腸膚膁腎腫脹脅膽勝朧腖臚脛膠脈膾髒臍腦膿臠腳脫腡臉臘醃膕齶膩靦膃騰臏臢輿艤艦艙艫艱豔艸藝節羋薌蕪蘆蓯葦藶莧萇蒼苧蘇檾蘋莖蘢蔦塋煢繭荊薦薘莢蕘蓽蕎薈薺蕩榮葷滎犖熒蕁藎蓀蔭蕒葒葤藥蒞蓧萊蓮蒔萵薟獲蕕瑩鶯蓴蘀蘿螢營縈蕭薩蔥蕆蕢蔣蔞藍薊蘺蕷鎣驀薔蘞藺藹蘄蘊藪槁蘚虜慮虛蟲虯蟣雖蝦蠆蝕蟻螞蠶蠔蜆蠱蠣蟶蠻蟄蛺蟯螄蠐蛻蝸蠟蠅蟈蟬蠍螻蠑螿蟎蠨釁銜補襯袞襖嫋褘襪襲襏裝襠褌褳襝褲襇褸襤繈襴見觀覎規覓視覘覽覺覬覡覿覥覦覯覲覷觴觸觶讋譽謄訁計訂訃認譏訐訌討讓訕訖訓議訊記訒講諱謳詎訝訥許訛論訩訟諷設訪訣證詁訶評詛識詗詐訴診詆謅詞詘詔詖譯詒誆誄試詿詩詰詼誠誅詵話誕詬詮詭詢詣諍該詳詫諢詡譸誡誣語誚誤誥誘誨誑說誦誒請諸諏諾讀諑誹課諉諛誰諗調諂諒諄誶談誼謀諶諜謊諫諧謔謁謂諤諭諼讒諮諳諺諦謎諞諝謨讜謖謝謠謗諡謙謐謹謾謫譾謬譚譖譙讕譜譎讞譴譫讖穀豶貝貞負貟貢財責賢敗賬貨質販貪貧貶購貯貫貳賤賁貰貼貴貺貸貿費賀貽賊贄賈賄貲賃賂贓資賅贐賕賑賚賒賦賭齎贖賞賜贔賙賡賠賧賴賵贅賻賺賽賾贗讚贇贈贍贏贛赬趙趕趨趲躉躍蹌蹠躒踐躂蹺蹕躚躋踴躊蹤躓躑躡蹣躕躥躪躦軀車軋軌軒軑軔轉軛輪軟轟軲軻轤軸軹軼軤軫轢軺輕軾載輊轎輈輇輅較輒輔輛輦輩輝輥輞輬輟輜輳輻輯轀輸轡轅轄輾轆轍轔辭辯辮邊遼達遷過邁運還這進遠違連遲邇逕跡適選遜遞邐邏遺遙鄧鄺鄔郵鄒鄴鄰鬱郤郟鄶鄭鄆酈鄖鄲醞醱醬釅釃釀釋裏钜鑒鑾鏨釓釔針釘釗釙釕釷釺釧釤鈒釩釣鍆釹鍚釵鈃鈣鈈鈦鈍鈔鍾鈉鋇鋼鈑鈐鑰欽鈞鎢鉤鈧鈁鈥鈄鈕鈀鈺錢鉦鉗鈷缽鈳鉕鈽鈸鉞鑽鉬鉭鉀鈿鈾鐵鉑鈴鑠鉛鉚鈰鉉鉈鉍鈹鐸鉶銬銠鉺銪鋏鋣鐃銍鐺銅鋁銱銦鎧鍘銖銑鋌銩銛鏵銓鉿銚鉻銘錚銫鉸銥鏟銃鐋銨銀銣鑄鐒鋪鋙錸鋱鏈鏗銷鎖鋰鋥鋤鍋鋯鋨鏽銼鋝鋒鋅鋶鐦鐧銳銻鋃鋟鋦錒錆鍺錯錨錡錁錕錩錫錮鑼錘錐錦鍁錈錇錟錠鍵鋸錳錙鍥鍈鍇鏘鍶鍔鍤鍬鍾鍛鎪鍠鍰鎄鍍鎂鏤鎡鏌鎮鎛鎘鑷鐫鎳鎿鎦鎬鎊鎰鎔鏢鏜鏍鏰鏞鏡鏑鏃鏇鏐鐔钁鐐鏷鑥鐓鑭鐠鑹鏹鐙鑊鐳鐶鐲鐮鐿鑔鑣鑞鑲長門閂閃閆閈閉問闖閏闈閑閎間閔閌悶閘鬧閨聞闥閩閭闓閥閣閡閫鬮閱閬闍閾閹閶鬩閿閽閻閼闡闌闃闠闊闋闔闐闒闕闞闤隊陽陰陣階際陸隴陳陘陝隉隕險隨隱隸雋難雛讎靂霧霽黴靄靚靜靨韃鞽韉韝韋韌韍韓韙韞韜韻頁頂頃頇項順須頊頑顧頓頎頒頌頏預顱領頗頸頡頰頲頜潁熲頦頤頻頮頹頷頴穎顆題顒顎顓顏額顳顢顛顙顥纇顫顬顰顴風颺颭颮颯颶颸颼颻飀飄飆飆飛饗饜飣饑飥餳飩餼飪飫飭飯飲餞飾飽飼飿飴餌饒餉餄餎餃餏餅餑餖餓餘餒餕餜餛餡館餷饋餶餿饞饁饃餺餾饈饉饅饊饌饢馬馭馱馴馳驅馹駁驢駔駛駟駙駒騶駐駝駑駕驛駘驍罵駰驕驊駱駭駢驫驪騁驗騂駸駿騏騎騍騅騌驌驂騙騭騤騷騖驁騮騫騸驃騾驄驏驟驥驦驤髏髖髕鬢魘魎魚魛魢魷魨魯魴魺鮁鮃鯰鱸鮋鮓鮒鮊鮑鱟鮍鮐鮭鮚鮳鮪鮞鮦鰂鮜鱠鱭鮫鮮鮺鯗鱘鯁鱺鰱鰹鯉鰣鰷鯀鯊鯇鮶鯽鯒鯖鯪鯕鯫鯡鯤鯧鯝鯢鯰鯛鯨鯵鯴鯔鱝鰈鰏鱨鯷鰮鰃鰓鱷鰍鰒鰉鰁鱂鯿鰠鼇鰭鰨鰥鰩鰟鰜鰳鰾鱈鱉鰻鰵鱅鰼鱖鱔鱗鱒鱯鱤鱧鱣鳥鳩雞鳶鳴鳲鷗鴉鶬鴇鴆鴣鶇鸕鴨鴞鴦鴒鴟鴝鴛鴬鴕鷥鷙鴯鴰鵂鴴鵃鴿鸞鴻鵐鵓鸝鵑鵠鵝鵒鷳鵜鵡鵲鶓鵪鶤鵯鵬鵮鶉鶊鵷鷫鶘鶡鶚鶻鶿鶥鶩鷊鷂鶲鶹鶺鷁鶼鶴鷖鸚鷓鷚鷯鷦鷲鷸鷺鸇鷹鸌鸏鸛鸘鹺麥麩黃黌黶黷黲黽註'
  if (!currentEncoding) {
    j = s
    s = t
    t = j
  }
  for (let i = 0; i < text.length; i++) {
    j = s.indexOf(text[i])
    result += j === -1 ? text[i] : t[j]
  }
  return result
}
function compress (
  base64, // 源图片
  rate // 缩放比例
) {
  // 处理缩放，转格式
  var _img = new Image();
  _img.src = base64;
  return new Promise((resolve, reject) => {
    _img.onload = function () {
      var _canvas = document.createElement('canvas');
      var w = this.width / rate;
      var h = this.height / rate;
      _canvas.setAttribute('width', w);
      _canvas.setAttribute('height', h);
      _canvas.getContext('2d').drawImage(this, 0, 0, w, h);
      var _base64 = _canvas.toDataURL('image/png');
      _canvas.toBlob(function (blob) {
          if (blob.size < 150 * 200) { // 如果还大，继续压缩
              resolve(base64);
          } else {
              resolve(_base64);
          }
      }, 'image/png');
  }
  })
}

// 单页pdf转图片
export async function getBase64FromSinglePDF (url, index = 1) {
  let NIMG = `data:image/jpeg;base64,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`
  try {
    let pdf = await window.PDFJS.getDocument(url)
    let page = await pdf.getPage(index)
    let viewport = page.getViewport(index)
    // Prepare canvas using PDF page dimensions.
    let canvas = document.createElement('canvas')
    let context = canvas.getContext('2d')
    canvas.height = viewport.height
    canvas.width = viewport.width
    // Render PDF page into canvas context.
    let renderContext = {
      canvasContext: context,
      viewport: viewport
    }
    await page.render(renderContext)
    let base64 = canvas.toDataURL('image/png', 1)
    let compress64 = await compress(base64, 10)
    return compress64
  } catch (err) {
    return NIMG
  }
}

// 图片合并
export async function mergeImages (imageUrls) {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  let totalHeight = 0
  let totalWidth = 0
  for (const imageUrl of imageUrls) {
    const image = new Image()
    image.src = imageUrl
    await new Promise((resolve, reject) => {
      image.onload = () => resolve()
      image.onerror = reject
    })
    totalHeight += image.height
    totalWidth = Math.max(totalWidth, image.width)
  }
  canvas.width = totalWidth
  canvas.height = totalHeight
  let currentWidth = 0
  for (const imageUrl of imageUrls) {
    const image = new Image()
    image.src = imageUrl
    await new Promise((resolve, reject) => {
      image.onload = () => resolve()
      image.onerror = reject
    })
    ctx.drawImage(image, currentWidth, 0)
    currentWidth += image.width
  }
  return canvas.toDataURL('image/png', 1)
}

export async function mergePDFs (pdfUrls) {
  // 创建一个新的空白PDF文档
  const mergedPdfDoc = await PDFDocument.create()
  let basic = null
  for (const pdfUrl of pdfUrls) {
    // 获取PDF文件的二进制数据
    const pdfBytes = await fetch(pdfUrl).then(response => response.arrayBuffer())

    // 将获取到的PDF文件添加到新的文档中
    const pdfDoc = await PDFDocument.load(pdfBytes)
    // 如果单个PDF为多页，则要一页一页往新建的PDF中添加
    const copiedPages = await mergedPdfDoc.copyPages(pdfDoc, pdfDoc.getPageIndices())
    copiedPages.forEach(page => {
      let size = page.getSize()
      if (basic === null) {
        basic = size
      }
      page.scale(basic.width / size.width, basic.height / size.height)
      mergedPdfDoc.addPage(page)
    })
  }

  // 将合并后的PDF保存为Blob对象
  const mergedPdfBytes = await mergedPdfDoc.save()
  const mergedPdfBlob = new Blob([mergedPdfBytes], { type: 'application/pdf' })
  // 创建下载链接
  // const downloadLink = document.createElement('a');
  // downloadLink.href = URL.createObjectURL(mergedPdfBlob);
  // // 设置下载文件名
  // downloadLink.download = 'mergedPdf.pdf';
  // 触发下载
  // downloadLink.click();
  return URL.createObjectURL(mergedPdfBlob)
}

export async function resizePDF (pdfUrl) {
  const pdfBytes = await fetch(pdfUrl).then(response => response.arrayBuffer())
  const pdfDoc = await PDFDocument.load(pdfBytes)
  // const page = pdfDoc.getPage(0)
  // const { width, height } = page.getSize()
  // page.scale(height / (0.82 * width), 1)
  const mergedPdfBytes = await pdfDoc.save()
  const mergedPdfBlob = new Blob([mergedPdfBytes], { type: 'application/pdf' })
  return URL.createObjectURL(mergedPdfBlob)
}
